import { $post } from '@/api'
import { userStore } from '@/store/user'
import $msg from '@/utils/message'
import { parse, parseUrl, stringify } from 'query-string'
import React, { useEffect } from 'react'
import { RouteComponentProps } from 'react-router'
import { shopStore } from '@/store/shop'
import { socketManager } from '@/api/webstock.tsx'
import { staffStore } from '@/store/staff'

const Privilege: React.FC<{} & RouteComponentProps> = props => {
    let url: any = {}
    const search = parse(window.location.hash.replace(/\/privilege\?/, ''))
    url = parseUrl(search.redirect as string)

    useEffect(() => {
        const shopId = url.query.shopId || localStorage.getItem('shopId')
        localStorage.setItem('shopId', shopId as string)
        init()
            .then(() => {
                socketManager.start()
                props.history.replace({
                    pathname: url.url,
                    search: stringify(url.query),
                })
            })
            .catch(e => {
                // openMessage(MessageType.error, "获取用户信息失败，将无法使用系统")
            })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    async function init() {
        await getToken()
        await Promise.all([getShopInfo(), getUserInfo(), getStaffInfo()]).then(() => {
            if (process.env.NODE_ENV === 'production') {
                setTimeout(() => {
                    // @ts-ignore
                    window.SenguoFeedback &&
                        // @ts-ignore
                        new window.SenguoFeedback({
                            shopId: Number(localStorage.getItem('shopId')),
                            shopType: 'new_ls',
                            passport_id: userStore.userInfo?.passport_id,
                            env: process.env.NODE_ENV,
                        })
                }, 1000)
            }
        })
        shopStore.getShopConfig()
    }

    function getToken() {
        return new Promise((resolve, reject) => {
            $post({
                url: '/user/gettoken',
            })
                .then(data => {
                    localStorage.setItem('token', data.token)
                    userStore.setToken(data.token)
                    resolve()
                })
                .catch((e: any) => {
                    e.message && $msg('error', e.message)
                    reject()
                })
        })
    }

    function getShopInfo() {
        return new Promise((resolve, reject) => {
            $post({
                url: '/shop/getshopinfo',
            })
                .then(data => {
                    shopStore.setShopInfo(data)
                    resolve()
                })
                .catch(e => {
                    reject()
                })
        })
    }

    function getUserInfo() {
        return new Promise((resolve, reject) => {
            $post({
                url: '/user/getuserinfo',
            })
                .then(res => {
                    userStore.setUserInfo(res.user)
                    resolve()
                })
                .catch(e => {
                    reject()
                })
        })
    }

    function getStaffInfo() {
        return new Promise((resolve, reject) => {
            $post({
                url: '/staff/getstaffinfo',
            })
                .then(res => {
                    staffStore.setStaffInfo(res)
                    resolve()
                })
                .catch(e => {
                    reject()
                })
        })
    }

    return <div>Privilege</div>
}

export default Privilege
